import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CalibrationConfig } from './types';
import { CalibrationUI } from './components/CalibrationUI';
import { ScoringView } from './components/ScoringView';
import { ScoreAdmin } from './components/ScoreAdmin';

const STORAGE_KEY = 'skeescore-calibration';
const REQUIRED_VALUES = [10, 20, 30, 40, 50]; // Required hole values

function isCalibrationComplete(config: CalibrationConfig | null): boolean {
  if (!config) return false;

  // Check for START zone
  if (!config.startZone) return false;

  // Check for GUTTER zone
  if (!config.gutterZone) return false;

  // Check for all required hole values (10, 20, 30, 40, 50)
  const holeValues = config.holes.map(h => h.value);
  const hasAllRequiredValues = REQUIRED_VALUES.every(value => holeValues.includes(value));

  return hasAllRequiredValues;
}

function MainApp() {
  const [calibrationConfig, setCalibrationConfig] = useState<CalibrationConfig | null>(null);

  // Load calibration from localStorage on mount
  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      try {
        const config: CalibrationConfig = JSON.parse(saved);
        // Only use saved config if it's complete
        if (isCalibrationComplete(config)) {
          setCalibrationConfig(config);
        }
      } catch (e) {
        console.error('Failed to load calibration:', e);
      }
    }
  }, []);

  const handleCalibrationComplete = (config: CalibrationConfig) => {
    setCalibrationConfig(config);
  };

  const handleRecalibrate = () => {
    setCalibrationConfig(null);
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f5f5f5' }}>
      {!calibrationConfig ? (
        <CalibrationUI onComplete={handleCalibrationComplete} />
      ) : (
        <ScoringView config={calibrationConfig} onRecalibrate={handleRecalibrate} />
      )}
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MainApp />} />
        <Route path="/scoreadmin" element={<ScoreAdmin />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;

